import { call, put, takeLatest } from 'redux-saga/effects';
import { type AxiosResponse } from 'axios';

import { getConfigs } from '../../services/configsService';

import { type IConfigDataType, setConfigsData, setLoading } from './slices';
import * as actions from './actions';

function* getConfigsApi() {
  try {
    yield put(setLoading(true));
    const { data }: AxiosResponse<IConfigDataType> = yield call(getConfigs);
    yield put(setConfigsData(data));
  } catch (err) {
    console.error(err);
  } finally {
    yield put(setLoading(false));
  }
}

export function* watchConfigsSaga() {
  yield takeLatest(actions.getConfigsApi.type, getConfigsApi);
}
